<script setup lang="ts">
import type { IDeposit } from '~/components/entity/deposit'
import { relevantOptions } from '~/components/entity/deposit'

const { deposit } = defineProps<{ deposit: IDeposit }>()

const activeOptions = relevantOptions
  .filter((opt) => deposit[opt.name])
  .map((opt) => ({ ...opt, icon: 'newspaper' }))
</script>

<template>
  <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
    <div
      v-for="item in activeOptions"
      :key="item.name"
      class="flex items-center gap-2 rounded-md bg-gray-100 p-4"
    >
      <div class="rounded-md bg-white p-2"><UiIcon :name="item.icon" /></div>
      <div class="text-sm">
        {{ $t(item.text) }}
      </div>
    </div>
  </div>
</template>
